<!--
 * @Author: your name
 * @Date: 2020-10-20 08:10:45
 * @LastEditTime: 2020-10-20 11:26:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wzl\src\components\about\culture.vue
-->
<template>
  <div class="wrapper">
    <p class="pub-title">企业文化</p>
    <p class="pub-sub-title">company culture</p>
    <div class="box">
      <template v-for="(item, index) in list">
        <div
          v-if="(index + 1) % 2 !== 0"
          :style="{
            backgroundImage: 'url(' + item.img + ')',
          }"
        ></div>
        <div v-else>
          <div v-show="item.title1 || item.intro1">
            <p class="title">{{ item.title1 }}：</p>
            <p class="desc">
              {{ filterText(item.intro1, 20) }}
            </p>
          </div>
          <div v-show="item.title2 || item.intro2">
            <p class="title">{{ item.title2 }}：</p>
            <p class="desc">
              {{ filterText(item.intro2, 20) }}
            </p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { company_culture } from '../../utils/api'
export default {
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    company_culture((r) => {
      this.list = r.data
    })
  },
}
</script>

<style lang="less" scoped >
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 80px 0;
  .pub-sub-title {
    margin-bottom: 40px;
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    & > div {
      height: 300px;
      width: 400px;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 40px;
      box-sizing: border-box;
      background-color: rgb(250, 250, 250);
      transition: all 0.15s linear;
      div:last-child {
        margin-top: 40px;
      }
      .title {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
        transition: all 0.15s linear;
      }
      .desc {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 27px;
        color: #333333;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: all 0.15s linear;
      }
    }
    & > div:hover {
      background-color: #006C8F;
      .title {
        color: white;
      }
      .desc {
        color: white;
      }
    }
  }
}
@media (max-width: 767px) {
  .wrapper {
    padding: 0.68rem 0;
    box-sizing: border-box;
    .box {
      & > div {
        width: 50%;
        height: 2.82rem;
        padding: 0.2rem 0.24rem;
        div:last-child {
          margin-top: 0.12rem;
        }
        .title {
          font-size: 0.28rem;
          margin-bottom: 0.06rem;
        }
        .desc {
          font-size: 0.24rem;
          line-height: 0.4rem;
        }
      }
    }
  }
}
</style>